import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface Props {
  skuCount: number;
  // Pre-formatted subtotal, or null to hide the subtotal half of the row
  subtotalDisplay: string | null;
  unitCount: number;
}

export const InboundDetailSummaryRow: React.FC<Props> = ({
  skuCount,
  subtotalDisplay,
  unitCount,
}) => {
  const [styles, theme] = useStyles();

  return (
    <View style={styles.container} testID="inbound-detail-summary-row">
      <Typography
        color={theme.sk.color.text.primary}
        flexShrink={1}
        variant="paragraph-md"
      >
        {`${i18n.t(
          skuCount === 1
            ? 'order_inbound_detail.summary.sku_count'
            : 'order_inbound_detail.summary.sku_count_plural',
          { count: skuCount },
        )} • ${i18n.t(
          unitCount === 1
            ? 'order_inbound_detail.summary.unit_count'
            : 'order_inbound_detail.summary.unit_count_plural',
          { count: unitCount },
        )}`}
      </Typography>

      {subtotalDisplay === null ? null : (
        <View style={styles.subtotalContainer}>
          <Typography variant="paragraph-md">
            {i18n.t('order_inbound_detail.summary.subtotal')}
          </Typography>

          <Typography variant="paragraph-md-600">{subtotalDisplay}</Typography>
        </View>
      )}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    backgroundColor: theme.sk.color.bg.primary.default,
    borderBottomColor: theme.sk.color.border.primary,
    borderBottomWidth: 1,
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'space-between',
    marginLeft: 4,
    padding: 16,
  },
  subtotalContainer: {
    flexDirection: 'row',
    gap: 4,
  },
}));
